// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".number_pro{color:#fff;font-size:10px;font-weight:700;padding:2px 6px;border-radius:20px;-webkit-transform:translateX(-50%) translateY(75%);transform:translateX(-50%) translateY(75%);position:absolute;bottom:0;left:50%}.conv{overflow-y:auto!important;height:-webkit-max-content;height:-moz-max-content;height:max-content;max-height:100%;min-height:100vh!important}", ""]);
// Exports
module.exports = exports;
